import { Link } from "react-router-dom";
import { Plane } from "lucide-react";

const AUTH_IMG =
  "https://images.unsplash.com/photo-1531329818183-bba7e80bfecd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxjb21tZXJjaWFsJTIwYWlycGxhbmUlMjBzdW5zZXQlMjBjaW5lbWF0aWN8ZW58MHx8fHwxNzgzNzgyOTQ0fDA&ixlib=rb-4.1.0&q=70&w=1920&auto=format"; // Unsplash resizes to 1920px wide and serves AVIF/WebP (2.5 MB → ~50 KB)

export const AuthLayout = ({ title, subtitle, children, footer }) => {
  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-[#0A0B10] px-5 py-16">
      <div className="absolute inset-0">
        <img src={AUTH_IMG} alt="" className="h-full w-full object-cover opacity-40" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0B10] via-[#0A0B10]/85 to-[#0A0B10]/60" />
      </div>

      <div className="relative z-10 w-full max-w-md" data-testid="auth-card">
        <div className="mb-8 text-center">
          <Link to="/" data-testid="auth-logo-home" className="inline-flex flex-col items-center gap-3">
            <span className="flex h-14 w-14 items-center justify-center rounded-full bg-[#8A1538] shadow-[0_0_28px_rgba(212,175,55,0.25)]">
              <Plane className="h-6 w-6 -rotate-45 text-[#D4AF37]" />
            </span>
            <span className="font-display text-lg font-bold tracking-tight text-[#FDFBF7]">
              Air India Virtual
            </span>
          </Link>
          <p className="mt-1 text-xs text-[#A1A1AA]">Click the logo to return home</p>
        </div>

        <div className="glass rounded-2xl p-8">
          <h1 className="font-display text-2xl font-bold tracking-tight text-[#FDFBF7]">{title}</h1>
          {subtitle && <p className="mt-2 text-sm text-[#A1A1AA]">{subtitle}</p>}
          <div className="mt-6">{children}</div>
        </div>

        {footer && <div className="mt-6 text-center text-sm text-[#A1A1AA]">{footer}</div>}
      </div>
    </div>
  );
};
